import { createContext } from "react";
import { getFooterLinks } from "../../../config";

export type GetLinkTargetResult = {
  target: "_self" | "_blank";
  rel?: string;
};

export type FooterContextType = {
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  links: ReturnType<typeof getFooterLinks>;
  handleFooterLinkClick: (
    event: React.MouseEvent<HTMLElement>,
    id: string
  ) => void;
  getLinkTarget: (url: string | undefined) => GetLinkTargetResult;
};

const defaultGetLinkTarget: FooterContextType["getLinkTarget"] = () => ({
  target: "_blank",
  rel: "noopener noreferrer",
});

export const FooterContext = createContext<FooterContextType>({
  isExpanded: false,
  setIsExpanded: () => {},
  links: getFooterLinks(),
  handleFooterLinkClick: () => {},
  getLinkTarget: defaultGetLinkTarget,
});
